import React from 'react';
import { Text } from 'atoms/Text/Text';
import { Styles } from './styles';
import { defaultTheme } from 'constants/theme/defaultTheme';

type PillsProps = {
  items: string[];
};

export const Pills: React.FC<PillsProps> = ({ items }) => {
  return (
    <Styles.Wrapper>
      {items.map(name => (
        <Styles.Pill key={name}>
          <Text.button2 color={defaultTheme.colors.deepGrey}>{name}</Text.button2>
        </Styles.Pill>
      ))}
    </Styles.Wrapper>
  );
};
